jQuery(document).ready(function() {
var section = document.querySelector("#content-feed"),
counter = 0,
loader = '<div class="loader"><div class="loader-bounce1"></div><div class="loader-bounce2"></div></div>',
loadMoreButton = '<div class="load-more-button"><a class="block w-full bg-tuna font-sans font-normal text-whisper text-center text-1 mt-2 md:mt-3 py-0.5 px-1 rounded-4 hover:text-saffron relative z-30 cursor-pointer">'+ajax.loadmore+'</a></div>',
isScrollFnExecuted = false; //variable to check if scroll funciton is executed or not. Used to prevent sending multiple request to the server on scroll.

/*
	On scroll make a request to the server with page artibutes. On return, append articles to the DOM.
	This should not be fired more than twice.
	Page options e.g. (front page) - They are set on every template file
	pageOpts = {
		name: "home",
		taxonomy:"page",
		cpt:"post" - Custom Post Type
	}
*/
var loadMoreOnScroll = function () {
	jQuery.ajax({
		url: ajax.ajaxurl,
		dataType: "html",
		type: "POST",
		data: {
			action: "load_articles",
			pageOpts: (typeof pageOpts !== 'undefined') ? pageOpts : {} ,
			ids: (typeof ids  !== 'undefined') ? ids : []
		},
		beforeSend: function () {
			jQuery('#content-feed').append(loader);
		},
		success: function (data) {
			jQuery('.loader').remove();
			if (data !== 'false') { //if there is data
				jQuery("#content-feed").append(data);

				//if no more posts, update loadMore variable
				var $script = $(data).filter('script:contains("loadMore")').first(); //fetch new load more value
				if ($script.length > 0) {
					var newValue = $script.text().substring($script.text().indexOf("=") + 1, $script.text().length);
					loadMore = JSON.parse(newValue.trim());
				}

				if (counter == 2 && loadMore) { // when the fucntion is called for a second time
					jQuery("#content-feed").parent().append(loadMoreButton); //append a load more button
					document.querySelector(".load-more-button").addEventListener("click", loadMoreOnButtonClick); //add click event on the appended button
				}
				// After 1 second the "isScrollFnExecuted" will be set to "false" to allow the code inside the "if" statement (on scroll fn line 88) to be executed again
				setTimeout(() => {
					isScrollFnExecuted = false;
				}, 1500);
			}
			jQuery(document).trigger('ad_placement_load'); //see ads.js. Trigger this hook to load banners into the placements we've just loaded
		}
	});
};


/*
	Does the same thing as loadMoreOnScroll fn, just this will be fired on click event on load more button
*/
var loadMoreOnButtonClick = function () {
	jQuery.ajax({
		url: ajax.ajaxurl,
		dataType: 'html',
		type: 'POST',
		data: {
			action: 'load_articles',
			pageOpts: pageOpts,
			ids: ids,
		},
		beforeSend: function (xhr) {
			jQuery('.load-more-button').append(loader);
			jQuery('.load-more-button a').addClass('hidden');

		},
		success: function (data) {
			jQuery('.loader').remove();
			jQuery('.load-more-button a').removeClass('hidden');

			if (data != 'false') {

				jQuery("#content-feed").append(data);
				if (!loadMore) { //if there is no more data to be loaded, remove button
					jQuery(".load-more-button").remove();
				}
			}
			jQuery(document).trigger('ad_placement_load'); //see ads.js. Trigger this hook to load banners into the placements we've just loaded
		}
	});
};

function concat(...args) {
	return args.reduce((acc, val) => [...acc, ...val]);
}

function onScrollEvent() {
	if(typeof loadMore === 'undefined' || !loadMore) {
		window.removeEventListener('scroll', onScrollEvent, {passive:true});
		 return;
	}
	var scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
	if ( scrollTop > ((section.clientHeight / 2) + section.offsetTop - 100) && !isScrollFnExecuted && counter < 2) {
		// Set "isScrollFnExecuted" to "true" to prevent further execution
		isScrollFnExecuted = true;
		counter++;
		loadMoreOnScroll();
	}
}
if(section) {

	window.addEventListener('scroll', onScrollEvent, {passive:true});

	//If we have fallback pagination, remove it (and replace) with this script
	var $possiblePagination = $('nav.pagination');
	if($possiblePagination.length > 0) {
		$possiblePagination.detach();
	}
}
});


